export default __webpack_public_path__ + "static/media/pt.bd78d561.svg";